import {
  FETCH_BOOKINGS_DATA,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  FETCH_BOOKINGS_DETAILS_DATA,
  FETCH_BOOKINGS_DETAILS_SUCCESS,
  FETCH_BOOKINGS_DETAILS_FAILURE,
} from "./actionTypes";

/**
 * @param {Object} params
 * @param {number} [params.page=1] - Page number (1-based)
 * @param {number} [params.limit=10] - Items per page
 * @param {string} [params.driverId] - Optional driver filter
 * @param {string} [params.search] - Optional search (if API supports it)
 */
export const fetchBookingsData = (params = {}) => ({
  type: FETCH_BOOKINGS_DATA,
  payload: {
    page: params.page ?? 1,
    limit: params.limit ?? 10,
    driverId: params.driverId,
    search: params.search,
  },
});

export const fetchBookingsSuccess = (data) => ({
  type: FETCH_BOOKINGS_SUCCESS,
  payload: data,
});

export const fetchBookingsFailure = (error) => ({
  type: FETCH_BOOKINGS_FAILURE,
  payload: error,
});

export const fetchBookingsDetailsData = (id) => ({
  type: FETCH_BOOKINGS_DETAILS_DATA,
  payload: id,
});

export const fetchBookingsDetailsSuccess = (data) => ({
  type: FETCH_BOOKINGS_DETAILS_SUCCESS,
  payload: data,
});

export const fetchBookingsDetailsFailure = (error) => ({
  type: FETCH_BOOKINGS_DETAILS_FAILURE,
  payload: error,
});
